<template>
  <div class="header header-dashboard" id="background">
    <div class="container-fluid">
      <div class="header-left">
        <div id="SidebarToggle" @click="toggleNav()" class="header-menu-icon">
          <vue-material-icon name="menu" :size="32"></vue-material-icon>
        </div>
      </div>

      <div class="header-center">
        <router-link to="/">
          <img v-lazy="logoImg" alt="logo" />
        </router-link>
      </div>

      <!-- <div class="header-right">
        <div class="header-message">
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/notification">
              <vue-material-icon name="notifications_none" :size="28"></vue-material-icon>
            </b-nav-item>
            <b-nav-item to="/cart">
              <vue-material-icon name="shopping_cart" :size="28"></vue-material-icon>
            </b-nav-item>
          </b-navbar-nav>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import {
  getDomainbaseVendorInfo,
  getmasterConfiguration
} from "./../services/api";
import VueLazyload from "vue-lazyload";
import Vue from "vue";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});
export default {
  data: function() {
    return {
      logoImg: "",
      imageBaseUrl: "https://trakop.s3.amazonaws.com/"
    };
  },
  watch: {
    $route(to, from) {
      this.getVendorDetails();
    }
  },
  created() {
    this.getVendorDetails();
    // this.getMasterConfigDetails();
  },
  methods: {
    getVendorDetails() {
      var requestData = {
        domain: window.location.host
      };

      getDomainbaseVendorInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            localStorage.setItem("poweredBy", result.data.data.powered_by);
            document.getElementById("background").style.background =
              result.data.data.layout_color;
            document.getElementById("sidebarBackground").style.background =
              result.data.data.layout_color;

            this.logoImg = this.imageBaseUrl + result.data.data.website_logo;
            localStorage.setItem("vendorId", result.data.data.vendor_id);
            localStorage.setItem("metaTag", result.data.data.header_script);
            localStorage.setItem("websiteFavicon", result.data.data.favicon);
            localStorage.setItem(
              "splashBackground",
              result.data.data.splash_colour
            );

            document
              .getElementById("faviconNew")
              .setAttribute(
                "href",
                "https://trakop.s3.amazonaws.com/" + result.data.data.favicon
              );
            localStorage.setItem(
              "metaDescription",
              result.data.data.meta_description
            );
            localStorage.setItem(
              "metaKeywords",
              result.data.data.meta_keywords
            );
            localStorage.setItem("metaTitle", result.data.data.meta_title);
            localStorage.setItem("websiteName", result.data.data.website_title);
            document.getElementById("result").innerHTML =
              result.data.data.website_title;
            localStorage.setItem("logoImg", result.data.data.website_logo);
            // localStorage.setItem("headerColor", result.data.data.layout_color);
            localStorage.setItem("googleTrackId", result.data.data.google_id);
            localStorage.setItem(
              "androidPlaystore",
              result.data.data.customer_android_app_url
            );
            localStorage.setItem(
              "iosPlaystore",
              result.data.data.customer_ios_app_url
            );
            this.getMasterConfigDetails();
          }
        })
        .catch(error => {
          return;
        });
    },
    getMasterConfigDetails() {
      var requestData = {
        user_id: localStorage.getItem("vendorId")
      };

      getmasterConfiguration(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            // console.log(">>>.", result);
            var a = result.data.payment_method_detials;
            var b = a.filter(item => item.payment_method_name == "TMC1");
            localStorage.setItem("defaultLang", "en");
            localStorage.setItem("numberLength", b[0].val2);
            localStorage.setItem("countryCode", b[0].val1);
            localStorage.setItem("subscriptionTmc", result.data.TMC21);
            localStorage.setItem("isPrepaid", result.data.is_prepaid);

            var merchant_key    =   a.filter(item => item.payment_method_name == "Paypal");
            var paypalKey       =   merchant_key[0].merchant_key ? merchant_key[0].merchant_key : 0;
            localStorage.setItem("paypayKey", paypalKey);

            if(result.data.paypal === true) {
                localStorage.setItem("paypalStatus", true);
            } else {
                localStorage.setItem("paypalStatus", false);
            }
            if(result.data.paytm === true) {
                localStorage.setItem("paytmStatus", true);
            } else {
                localStorage.setItem("paytmStatus", false);
            }
            if(result.data.payu === true) {
                localStorage.setItem("payuStatus", true);
            } else {
                localStorage.setItem("payuStatus", false);
            }
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    toggleNav() {
      this.$parent.$emit("toggleNav");
    }
  }
};
</script>
<style lang="scss">
// @import "../assets/css/custom.scss";
</style>